
import { IChuongTrinhDaoTaoActionTypes } from "../../action-types/ctdt/IChuongTrinhDaoTaoActionTypes";
import { IChuongTrinhDaoTaoReducer } from "../../reducer-model/ctdt/IChuongTrinhDaoTaoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IChuongTrinhDaoTaoReducer = {
    status: eReducerStatusBase.is_not_initialization,
    chuongTrinhDaoTaos: [],
    namHoc: "",
    isLoadedAll: false,
    saoChepModal: {
        isOpen: false,
        status: eReducerStatusBase.is_completed,
        isCreateNew: false
    },
    importModal: {
        isOpen: false
    },
    clipboardDataCopy: {
        id_dt_goc: 0,
        id_dt_mons: [],
        id_dt_dich: 0,
        status: eReducerStatusBase.is_completed
    }
};
export const chuongTrinhDaoTaoReducer = (
    state: IChuongTrinhDaoTaoReducer = iniState,
    action: IChuongTrinhDaoTaoActionTypes
): IChuongTrinhDaoTaoReducer => {
    switch (action.type) {
        case "CHUONG_TRINH_DAO_TAO_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                namHoc: action.payload
            };
        case "CHUONG_TRINH_DAO_TAO_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                chuongTrinhDaoTaos: action.payload,
            };
        case "CHUONG_TRINH_DAO_TAO_LOAD_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUONG_TRINH_DAO_TAO_LOAD_ALL_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUONG_TRINH_DAO_TAO_LOAD_ALL_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                chuongTrinhDaoTaos: action.payload,
                isLoadedAll: true,
            };
        case "CHUONG_TRINH_DAO_TAO_LOAD_ALL_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUONG_TRINH_DAO_TAO_CHANGE_CTDT_SELECTED":
            return {
                ...state,
                chuongTrinhDaoTaoSelected: action.payload
            };
        case "CHUONG_TRINH_DAO_TAO_SHOW_EDIT_MODEL":
            return {
                ...state,
                isShowEditModal: true,
                chuongTrinhDaoTaoEditing: action.payload
            }
        case "CHUONG_TRINH_DAO_TAO_CLOSE_EDIT_MODEL":
            return {
                ...state,
                isShowEditModal: false,
                chuongTrinhDaoTaoEditing: undefined
            }
        case "CHUONG_TRINH_DAO_TAO_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "CHUONG_TRINH_DAO_TAO_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                // isShowEditModal: false
            }
        case "CHUONG_TRINH_DAO_TAO_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "CHUONG_TRINH_DAO_TAO_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "CHUONG_TRINH_DAO_TAO_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            }
        case "CHUONG_TRINH_DAO_TAO_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "CHUONG_TRINH_DAO_TAO_OPEN_COPY_MODAL":
            return {
                ...state,
                saoChepModal: {
                    ...state.saoChepModal,
                    isOpen: true,
                    chuongTrinhGoc: action.payload
                }
            }
        case "CHUONG_TRINH_DAO_TAO_CLOSE_COPY_MODAL":
            return {
                ...state,
                saoChepModal: {
                    ...state.saoChepModal,
                    isOpen: false,
                }
            }
        case "CHUONG_TRINH_DAO_TAO_COPY_CHANGE_CHUONG_TRINH_GOC":
            return {
                ...state,
                saoChepModal: {
                    ...state.saoChepModal,
                    chuongTrinhGoc: action.payload
                }
            }
        case "CHUONG_TRINH_DAO_TAO_COPY_CHANGE_CHUONG_TRINH_DICH":
            return {
                ...state,
                saoChepModal: {
                    ...state.saoChepModal,
                    chuongTrinhDich: action.payload
                }
            }
        case "CHUONG_TRINH_DAO_TAO_COPY_START":
            return {
                ...state,
                saoChepModal: {
                    ...state.saoChepModal,
                    status: eReducerStatusBase.is_saving
                }
            }
        case "CHUONG_TRINH_DAO_TAO_COPY_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                saoChepModal: {
                    ...state.saoChepModal,
                    isOpen: false,
                    status: eReducerStatusBase.is_completed
                }
            }
        case "CHUONG_TRINH_DAO_TAO_COPY_ERROR":
            return {
                ...state,
                saoChepModal: {
                    ...state.saoChepModal,
                    status: eReducerStatusBase.is_completed
                }
            }
        case "CHUONG_TRINH_DAO_TAO_COPY_CHANGE_CREATE_NEW":
            return {
                ...state,
                saoChepModal: {
                    ...state.saoChepModal,
                    isCreateNew: action.payload
                }
            }
        case "CHUONG_TRINH_DAO_TAO_UPLOAD_MODAL_OPEN":
            return {
                ...state,
                importModal: {
                    ...state.importModal,
                    isOpen: true,
                    chuongTrinh: action.payload
                }
            }
        case "CHUONG_TRINH_DAO_TAO_UPLOAD_MODAL_CLOSE":
            return {
                ...state,
                importModal: {
                    ...state.importModal,
                    isOpen: false,
                }
            }
        case "CHUONG_TRINH_DAO_TAO_COPY_CLIPBOARD_DATA":
            return {
                ...state,
                clipboardDataCopy: {
                    id_dt_goc: action.payload.id_dt_goc,
                    id_dt_mons: action.payload.id_dt_mons,
                    id_dt_dich: action.payload.id_dt_dich,
                    status: eReducerStatusBase.is_saving
                }
            }
        case "CHUONG_TRINH_DAO_TAO_PASTE_CLIPBOARD_DATA_START":
            return {
                ...state,
                clipboardDataCopy: {
                    ...state.clipboardDataCopy,
                    status: eReducerStatusBase.is_saving
                }
            }
        case "CHUONG_TRINH_DAO_TAO_PASTE_CLIPBOARD_DATA_SUCCESS":
            return {
                ...state,
                clipboardDataCopy: {
                    ...state.clipboardDataCopy,
                    status: eReducerStatusBase.is_completed
                }
                
            }
        case "CHUONG_TRINH_DAO_TAO_PASTE_CLIPBOARD_DATA_ERROR":
            return {
                ...state,
                clipboardDataCopy: {
                    ...state.clipboardDataCopy,
                    status: eReducerStatusBase.is_completed
                }
            }
        case "CHUONG_TRINH_DAO_TAO_UPDATE_TOTAL_TIN_CHI_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "CHUONG_TRINH_DAO_TAO_UPDATE_TOTAL_TIN_CHI_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "CHUONG_TRINH_DAO_TAO_UPDATE_TOTAL_TIN_CHI_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "CHUONG_TRINH_DAO_TAO_UPDATE_LOCK_STATUS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "CHUONG_TRINH_DAO_TAO_UPDATE_LOCK_STATUS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "CHUONG_TRINH_DAO_TAO_UPDATE_LOCK_STATUS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
};
